<div class="phone-input">
    <span>{{dialingCode}}</span>
    <input #phoneInput type="text" [textMask]="{mask: mask, guide: false}" pattern="07[0-9]{3} [0-9]{6}" name="PhoneNumber" class="form-control"
        [(ngModel)]="phoneNumber" (ngModelChange)="inputChanged()">
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/phone-input/phone-input.component.html